export class TransferConstructionSiteDetailModel {
  transferConstructionSiteDetailId: number = 0;
  transferConstructionSiteId: number = 0;
  articleId: number = 0;
  storeId: number = 0;
  quantity: number = 0;
  createDate: Date = new Date;
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}